import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";

export const usePoiActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function getPoiList(filters: any) {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            service: filters.service ? filters.service : undefined,
            address: filters.address ? filters.address : undefined,
            city: filters.city ? filters.city : undefined,
            name: filters.name ? filters.name : undefined,
            type: filters.type ? filters.type : undefined,
            status: filters.status ? filters.status : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data = await GET("sm/poi", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getPoiById(id: any) {
        let data = await GET("sm/poi/ext/" + id, true);
        return data?.result;
    }

    async function createPoi(payload: any) {
        return await POST("sm/poi/", payload, true)
    }

    async function updatePoi(payload: any) {
        return await PUT("sm/poi/", payload, true)
    }

    async function importFile(file: File, tenantId: string, dealerId : string) {
        let formData = new FormData();
        formData.append("file", file);
        return await POST(`sm/poi/upload-excel?tenant_id=${tenantId}&dealer_id=${dealerId}`, formData, true, {headers: {"Content-Type": "multipart/form-data"}})
    }

    async function getPoiServices() {
        return await GET("sm/poi/all-services", true);
    }

    async function getTemplates() {
        return await GET("sm/poi/all-templates", true);
    }

    async function getBrands(){
        return await GET("sm/poi/all-brands", true);
    }

    async function getAssistanceTypes(){
        return await GET("sm/poi/all-assistancetypes", true);
    }

    async function getChargingStations(){
        return await GET("sm/poi/all-chargingstations", true);
    }
    async function downloadTemplate() {

        return await GET("sm/poi/template.xlsx", true, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/vnd.ms-excel'
            }
        });
    }

    return {
        getPoiList,
        getPoiById,
        createPoi,
        updatePoi,
        importFile,
        downloadTemplate,
        getPoiServices,
        getTemplates,
        getBrands,
        getAssistanceTypes,
        getChargingStations
    };
}